import React from 'react';
import proptypes from 'prop-types';

const { string } = proptypes;

export const StorePodLoader = ({ height = '0.625rem' }) => {
  return (
    <div className="sui-animate-pulse">
      <div className="sui-w-auto sui-bg-strong sui-rounded-lg" style={{ height }} />
    </div>
  );
};

StorePodLoader.propTypes = {
  height: string
};

StorePodLoader.displayName = 'StorePodLoader';
